 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Intermediary Type
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        <v-data-table
          :headers="headers"
          :items="interTypeList"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
          :search="search"
          :custom-filter="customSearch"
        >
          <template v-slot:item="row"><tr>
              <td>{{ row.item.value }}</td>
              <td>{{ row.item.label }}</td>
              <td align="center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignInterType(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
             </tr></template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      labels: {
        interType: 'Intermediary Type',
        interTypeDesc: 'Description'
      },
      filters: {
        interType: undefined
      },
      headers: [
        { text: 'Intermediary Type', align: 'left', value: 'label' },
        { text: 'Description', align: 'left', value: 'value' },
        TableConst.tableActionHeader
      ],
      interTypeList: [],
      loading: false
    }
  },
  mounted() {
    this.doClearInterTypeFilters()
  },
  methods: {
    async doFetch() {
      this.loading = true
      this.interTypeList = []
      try {
        const apiUrl = this.$store.state.commons.menu.interTypeList
        if (apiUrl) {
          const result = await this.$http.get(apiUrl)
          if (result && result.data && result.data.data) {
            this.interTypeList = result.data.data
          }
        }
      } catch (e) {
      }
      this.loading = false
    },
    closeDialog() {
      this.filters.interType = ''
      this.$emit('close')
    },
    doClearInterTypeFilters() {
      this.filters.interType = ''
      this.doFetch()
    },
    doInterTypeFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryInterTypeFilterForm').then((result) => {
        if (result) {
          this.doFetch()
        }
      })
    },
    assignInterType(data) {
      this.$emit('assign-interType-data', data)
      this.$emit('assign-interType', data.value)
      this.$emit('close')
    }
  },
  computed: {},
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
